<template>
    <div :class="['flex items-center gap-2 overflow-x-auto py-2 px-1', classAdd]">
        <!-- All button -->
        <button
            @click="setCurrentItem(null)"
            :class="[
                'whitespace-nowrap px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200',
                activeItem === null
                    ? 'bg-blue-500 text-white shadow-md shadow-blue-500/20'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-dark-800 dark:text-gray-300 dark:hover:bg-dark-700'
            ]"
        >
            Semua
        </button>

        <!-- Filter items -->
        <button
            v-for="item in items"
            :key="item"
            @click="setCurrentItem(item)"
            :class="[
                'whitespace-nowrap px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200',
                activeItem === item
                    ? 'bg-blue-500 text-white shadow-md shadow-blue-500/20'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-dark-800 dark:text-gray-300 dark:hover:bg-dark-700'
            ]"
        >
            {{ item }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'FilterLane',
    props: {
        items: {
            type: Array,
            required: true
        },
        classAdd: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            activeItem: null
        }
    },
    methods: {
        setCurrentItem(item) {
            this.activeItem = item;
            this.$emit('setCurrentItem', item);
        }
    }
}
</script>

<style scoped>
/* Hide scrollbar but keep functionality */
.overflow-x-auto {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.overflow-x-auto::-webkit-scrollbar {
    display: none;  /* Chrome, Safari and Opera */
}
</style>